(() => {
  'use strict';
  const initProduct = (root) => {
    if (!root || root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';
    const form = root.querySelector('[data-product-form]');
    const price = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-product-add]');
    const addLabel = root.querySelector('[data-product-add-label]');
    const status = root.querySelector('[data-product-status]');
    const gallery = root.querySelector('[data-product-gallery]');
    const mediaItems = [...root.querySelectorAll('[data-product-media]')];
    const thumbnails = [...root.querySelectorAll('[data-product-thumbnail]')];
    const variantInputs = [...root.querySelectorAll('[data-product-variant]')];
    const sizeNudge = root.querySelector('[data-gallery-size-nudge]');
    const sizeNudgeToggle = root.querySelector('[data-gallery-size-nudge-toggle]');
    const sizeNudgeOptions = [...root.querySelectorAll('[data-gallery-size-option]')];
    const galleryPrevious = root.querySelector('[data-gallery-previous]');
    const galleryNext = root.querySelector('[data-gallery-next]');
    const thumbnailPrevious = root.querySelector('[data-thumbnail-previous]');
    const thumbnailNext = root.querySelector('[data-thumbnail-next]');
    const infoPopovers = [...root.querySelectorAll('.siwa-info-popover')];
    const sticky = root.querySelector('[data-product-sticky]');
    const stickyPicker = root.querySelector('[data-product-sticky-picker]');
    const stickyOptions = [...root.querySelectorAll('[data-product-sticky-variant]')];
    const stickyImage = root.querySelector('[data-product-sticky-image]') || root.querySelector('.siwa-product-sticky__image');
    const stickyVariantLabel = root.querySelector('[data-product-sticky-variant-label]');
    const stickyVariantPrice = root.querySelector('[data-product-sticky-variant-price]');
    const stickyAddButton = root.querySelector('[data-product-sticky-add]');
    const stickyAddLabel = root.querySelector('[data-product-sticky-add-label]');
    const storeVariantPanels = [...root.querySelectorAll('[data-siwa-store-variant]')];
    const storeStock = root.querySelector('[data-siwa-store-stock]');
    const storeRequests = new Map();
    let currentStoreVariant = '';
    const storeDialog = root.querySelector('[data-siwa-store-dialog]');
    const storeOpenButton = root.querySelector('[data-siwa-store-open]');
    const storeCloseButton = root.querySelector('[data-siwa-store-close]');
    let storeDialogOpener = null;
    let infoPopoverTimer;
    const registerGalleryInteraction = () => {
      if (!sizeNudge || !window.matchMedia('(max-width: 989px)').matches) return;
      sizeNudge.hidden = false;
    };
    const activateMedia = (mediaId, smooth = false, userInitiated = false) => {
      const target = mediaItems.find((media) => media.dataset.mediaId === String(mediaId));
      if (!target || target.hidden) return;
      mediaItems.forEach((media) => {
        const active = media === target;
        media.dataset.active = String(active);
        if (!active) media.querySelector('video')?.pause();
      });
      thumbnails.forEach((thumbnail) => {
        const selected = thumbnail.dataset.mediaId === String(mediaId);
        thumbnail.setAttribute('aria-selected', String(selected));
        thumbnail.tabIndex = selected ? 0 : -1;
        // Move only the thumbnail rail, never the page during initialization.
        if (selected && userInitiated) {
          const rail = thumbnail.parentElement;
          rail.scrollTo({ left: thumbnail.offsetLeft - rail.offsetLeft - (rail.clientWidth - thumbnail.offsetWidth) / 2, behavior: smooth ? 'smooth' : 'auto' });
        }
      });
      if (smooth && window.matchMedia('(min-width: 990px)').matches) {
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      if (userInitiated) registerGalleryInteraction();
    };
    const filterVariantMedia = (size, preferredMediaId) => {
      const normalizedSize = String(size || '').toLowerCase().replace(/\s+/g, '');
      [...mediaItems, ...thumbnails].forEach((item) => {
        if (!item.dataset.variantMediaRole) return;
        item.hidden = item.dataset.variantSize !== normalizedSize;
      });
      sizeNudgeOptions.forEach((option) => {
        option.setAttribute('aria-pressed', String(option.dataset.variantSize === normalizedSize));
      });
      const active = mediaItems.find((media) => media.dataset.active === 'true' && !media.hidden);
      const preferred = mediaItems.find((media) => media.dataset.mediaId === String(preferredMediaId) && !media.hidden);
      const selectedBottle = mediaItems.find((media) => media.dataset.variantMediaRole === 'bottle' && media.dataset.variantSize === normalizedSize && !media.hidden);
      const next = preferred || active || selectedBottle || mediaItems.find((media) => !media.hidden);
      if (next) activateMedia(next.dataset.mediaId);
    };
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => activateMedia(thumbnail.dataset.mediaId, false, true));
      thumbnail.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const increment = event.key === 'ArrowRight' ? 1 : -1;
        const visibleThumbnails = thumbnails.filter((item) => !item.hidden);
        const index = visibleThumbnails.indexOf(thumbnail);
        const next = visibleThumbnails[(index + increment + visibleThumbnails.length) % visibleThumbnails.length];
        activateMedia(next.dataset.mediaId, false, true);
        next.focus({ preventScroll: true });
      });
    });

    const moveGallery = (increment) => {
      const visibleMedia = mediaItems.filter((media) => !media.hidden);
      const currentIndex = Math.max(0, visibleMedia.findIndex((media) => media.dataset.active === 'true'));
      const next = visibleMedia[(currentIndex + increment + visibleMedia.length) % visibleMedia.length];
      if (next) activateMedia(next.dataset.mediaId, false, true);
    };
    galleryPrevious?.addEventListener('click', () => moveGallery(-1));
    galleryNext?.addEventListener('click', () => moveGallery(1));
    thumbnailPrevious?.addEventListener('click', () => moveGallery(-1));
    thumbnailNext?.addEventListener('click', () => moveGallery(1));

    let touchStartX = null;
    gallery?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    gallery?.addEventListener('touchend', (event) => {
      if (touchStartX === null || !window.matchMedia('(max-width: 989px)').matches) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) < 42) return;
      const visibleMedia = mediaItems.filter((media) => !media.hidden);
      const currentIndex = visibleMedia.findIndex((media) => media.dataset.active === 'true');
      const increment = distance < 0 ? 1 : -1;
      const next = visibleMedia[(currentIndex + increment + visibleMedia.length) % visibleMedia.length];
      if (next) activateMedia(next.dataset.mediaId, false, true);
    }, { passive: true });

    sizeNudgeToggle?.addEventListener('click', () => {
      const willExpand = sizeNudge.dataset.state !== 'expanded';
      sizeNudge.dataset.state = willExpand ? 'expanded' : 'collapsed';
      sizeNudgeToggle.setAttribute('aria-expanded', String(willExpand));
    });

    const closeSizeNudge = () => {
      if (!sizeNudge) return;
      sizeNudge.dataset.state = 'collapsed';
      sizeNudgeToggle?.setAttribute('aria-expanded', 'false');
    };
    root.querySelector('[data-gallery-size-close]')?.addEventListener('click', () => {
      closeSizeNudge();
      sizeNudgeToggle?.focus({ preventScroll: true });
    });
    document.addEventListener('click', (event) => {
      if (sizeNudge && !sizeNudge.contains(event.target)) closeSizeNudge();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && sizeNudge?.dataset.state === 'expanded') {
        closeSizeNudge();
        sizeNudgeToggle?.focus({ preventScroll: true });
      }
    });

    sizeNudgeOptions.forEach((option) => {
      option.addEventListener('click', () => {
        const input = variantInputs.find((candidate) => candidate.value === option.dataset.variantId);
        if (!input || input.disabled) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        sizeNudge.dataset.state = 'collapsed';
        sizeNudgeToggle?.setAttribute('aria-expanded', 'false');
      });
    });

    const closeInfoPopovers = (except = null) => {
      window.clearTimeout(infoPopoverTimer);
      infoPopoverTimer = undefined;
      infoPopovers.forEach((popover) => {
        if (popover !== except) popover.removeAttribute('open');
      });
    };

    const scheduleInfoPopoverClose = (popover) => {
      window.clearTimeout(infoPopoverTimer);
      infoPopoverTimer = window.setTimeout(() => {
        popover.removeAttribute('open');
        infoPopoverTimer = undefined;
      }, 4000);
    };

    infoPopovers.forEach((popover) => {
      popover.addEventListener('toggle', () => {
        if (!popover.open) {
          if (!infoPopovers.some((other) => other.open)) closeInfoPopovers();
          return;
        }
        closeInfoPopovers(popover);
        scheduleInfoPopoverClose(popover);
        window.requestAnimationFrame(() => {
          const panel = popover.querySelector('.siwa-info-popover__panel');
          if (!panel) return;
          panel.style.removeProperty('--siwa-info-shift-x');
          popover.classList.remove('is-align-left', 'is-align-right');
          const bounds = panel.getBoundingClientRect();
          if (bounds.right > window.innerWidth - 10) popover.classList.add('is-align-right');
          else if (bounds.left < 10) popover.classList.add('is-align-left');
          const alignedBounds = panel.getBoundingClientRect();
          let viewportShift = 0;
          if (alignedBounds.left < 10) viewportShift = 10 - alignedBounds.left;
          else if (alignedBounds.right > window.innerWidth - 10) viewportShift = (window.innerWidth - 10) - alignedBounds.right;
          panel.style.setProperty('--siwa-info-shift-x', `${Math.round(viewportShift)}px`);
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (!infoPopovers.some((popover) => popover.contains(event.target))) closeInfoPopovers();
    });
    window.addEventListener('scroll', () => closeInfoPopovers(), { passive: true, capture: true });

    const syncStickyVariant = (variantId) => {
      const option = stickyOptions.find((candidate) => candidate.dataset.variantId === String(variantId));
      if (!option) return;
      const available = option.dataset.variantAvailable === 'true';
      if (stickyVariantLabel) stickyVariantLabel.textContent = option.dataset.variantLabel || '';
      if (stickyVariantPrice) stickyVariantPrice.textContent = option.dataset.variantPrice || '';
      if (stickyImage && option.dataset.variantImage) {
        stickyImage.removeAttribute('srcset');
        stickyImage.removeAttribute('sizes');
        stickyImage.src = option.dataset.variantImage;
      }
      if (stickyAddButton) {
        stickyAddButton.disabled = !available;
        stickyAddButton.dataset.available = String(available);
      }
      if (stickyAddLabel) stickyAddLabel.textContent = available ? 'Add to bag' : 'Sold out';
      stickyOptions.forEach((candidate) => candidate.setAttribute('aria-selected', String(candidate === option)));
    };

    const refreshStoreVariant = (variantId) => {
      const id = String(variantId || '');
      const detail = storeVariantPanels.find(panel => panel.hasAttribute('data-store-detail') && panel.dataset.siwaStoreVariant === id);
      if (!storeStock || !detail || !/^\d+$/.test(id)) return;
      // Shopify only exposes pickup data for the server-selected variant.
      // Fetch its small section, not the entire product page or other sizes.
      if (storeRequests.has(id)) return storeRequests.get(id);
      const url = new URL(storeStock.dataset.storeProductUrl, window.location.origin);
      if (url.origin !== window.location.origin) return;
      url.searchParams.set('variant', id);
      url.searchParams.set('section_id', 'siwa-pickup-availability');
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 8000);
      detail.setAttribute('aria-busy', 'true');
      const request = fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal })
        .then(response => { if (!response.ok) throw new Error('Pickup check unavailable'); return response.text(); })
        .then(html => {
          const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-siwa-store-response]');
          const data = JSON.parse(node?.textContent || 'null');
          if (!data || data.variantId !== id || data.locationId !== storeStock.dataset.storeLocationId || !['available', 'unavailable', 'unknown'].includes(data.status)) throw new Error('Invalid pickup response');
          const branch = storeStock.dataset.storeLocationName;
          const size = detail.dataset.storeSize;
          const available = data.status === 'available', unavailable = data.status === 'unavailable';
          detail.dataset.storeState = data.status;
          detail.querySelector('[data-store-status]').dataset.storeStatus = data.status;
          detail.querySelector('[data-store-heading]').textContent = available ? `${size} available for pickup` : unavailable ? `${size} — Pickup unavailable` : `Confirm ${size} pickup`;
          detail.querySelector('[data-store-description]').textContent = available ? `${storeStock.dataset.storeProductTitle} is currently available for pickup at ${branch}. Store stock can change during the day.` : unavailable ? `This size is currently unavailable for pickup at ${branch}. Try another size or check again later.` : `Live pickup availability could not be confirmed for this size. Please check with ${branch} before visiting.`;
          const summary = storeVariantPanels.find(panel => panel.hasAttribute('data-store-summary') && panel.dataset.siwaStoreVariant === id);
          if (summary) { summary.dataset.storeState = data.status; summary.textContent = `${branch} · ${available ? 'Pickup available' : unavailable ? 'Pickup unavailable' : 'Check store stock'}`; }
        })
        .catch(() => { /* Keep the truthful server state; never turn an error into "available". */ })
        .finally(() => { window.clearTimeout(timeout); detail.removeAttribute('aria-busy'); storeRequests.delete(id); });
      storeRequests.set(id, request);
      return request;
    };

    const syncStoreVariant = (variantId) => {
      currentStoreVariant = String(variantId);
      storeVariantPanels.forEach((panel) => {
        panel.hidden = panel.dataset.siwaStoreVariant !== currentStoreVariant;
      });
      refreshStoreVariant(currentStoreVariant);
    };

    const closeStoreDialog = () => {
      document.body.classList.remove('siwa-store-dialog-open');
      if (typeof storeDialog?.close === 'function') storeDialog.close();
      else storeDialog?.removeAttribute('open');
      storeDialogOpener?.focus?.({ preventScroll: true });
      storeDialogOpener = null;
    };

    storeOpenButton?.addEventListener('click', () => {
      refreshStoreVariant(currentStoreVariant);
      storeDialogOpener = storeOpenButton;
      document.body.classList.add('siwa-store-dialog-open');
      if (typeof storeDialog?.showModal === 'function') storeDialog.showModal();
      else storeDialog?.setAttribute('open', '');
      storeCloseButton?.focus({ preventScroll: true });
    });
    storeCloseButton?.addEventListener('click', closeStoreDialog);
    storeDialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeStoreDialog();
    });
    storeDialog?.addEventListener('click', (event) => {
      if (event.target !== storeDialog) return;
      const bounds = storeDialog.getBoundingClientRect();
      const inside = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
      if (!inside) closeStoreDialog();
    });

    variantInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        const available = input.dataset.available === 'true';
        if (price) price.textContent = input.dataset.price || '';
        if (addButton) { addButton.disabled = !available; addButton.dataset.available = String(available); }
        if (addLabel) addLabel.textContent = available ? (input.dataset.cartLabel || 'Add to cart') : 'Sold out';
        if (status) status.textContent = '';
        filterVariantMedia(input.dataset.variantSize, input.dataset.mediaId);
        if (input.dataset.mediaId && gallery) activateMedia(input.dataset.mediaId, true);
        syncStickyVariant(input.value);
        syncStoreVariant(input.value);
        if (input.dataset.url) window.history.replaceState({}, '', input.dataset.url);
      });
    });

    stickyOptions.forEach((option) => {
      option.addEventListener('click', () => {
        const input = variantInputs.find((candidate) => candidate.value === option.dataset.variantId);
        if (input && !input.disabled) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          const hiddenVariant = form?.querySelector('input[name="id"]');
          if (hiddenVariant) hiddenVariant.value = option.dataset.variantId;
          syncStickyVariant(option.dataset.variantId);
          if (option.dataset.mediaId) activateMedia(option.dataset.mediaId, true);
        }
        stickyPicker?.removeAttribute('open');
      });
    });

    stickyAddButton?.addEventListener('click', () => {
      if (!form || !addButton || stickyAddButton.disabled) return;
      form.requestSubmit(addButton);
    });

    if (sticky && addButton) {
      const setStickyVisible = (visible) => {
        sticky.dataset.visible = String(visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        sticky.inert = !visible;
        document.body.classList.toggle('siwa-product-sticky-visible', visible);
        if (!visible) stickyPicker?.removeAttribute('open');
      };
      if ('IntersectionObserver' in window) {
        const stickyObserver = new IntersectionObserver(([entry]) => {
          setStickyVisible(!entry.isIntersecting);
        }, { threshold: 0 });
        stickyObserver.observe(addButton);
      } else {
        const updateStickyVisibility = () => {
          const rect = addButton.getBoundingClientRect();
          setStickyVisible(rect.bottom < 0 || rect.top > window.innerHeight);
        };
        window.addEventListener('scroll', updateStickyVisibility, { passive: true });
        updateStickyVisibility();
      }
      document.addEventListener('pointerdown', (event) => {
        if (stickyPicker?.open && !stickyPicker.contains(event.target)) stickyPicker.removeAttribute('open');
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') stickyPicker?.removeAttribute('open');
      });
    }

    const initiallySelectedVariant = variantInputs.find((input) => input.checked) || form?.querySelector('input[name="id"]');
    if (initiallySelectedVariant) {
      syncStickyVariant(initiallySelectedVariant.value);
      syncStoreVariant(initiallySelectedVariant.value);
      if (initiallySelectedVariant.dataset?.variantSize) {
        filterVariantMedia(initiallySelectedVariant.dataset.variantSize, initiallySelectedVariant.dataset.mediaId);
      }
    }

    form?.addEventListener('submit', async (event) => {
      if (!addButton || addButton.disabled) return;
      event.preventDefault();
      const originalLabel = addLabel?.textContent || 'Add to cart';
      const originalStickyLabel = stickyAddLabel?.textContent || 'Add to bag';
      addButton.disabled = true;
      if (stickyAddButton) stickyAddButton.disabled = true;
      if (addLabel) addLabel.textContent = 'Adding';
      if (stickyAddLabel) stickyAddLabel.textContent = 'Adding';
      if (status) status.textContent = '';
      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootPath}cart/add.js`, { method:'POST', headers:{ Accept:'application/json' }, body:new FormData(form) });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || 'Could not add this fragrance.');
        const cartResponse = await fetch(`${rootPath}cart.js`, { headers:{ Accept:'application/json' } });
        const cart = cartResponse.ok ? await cartResponse.json() : null;
        if (cart) {
          document.querySelectorAll('.siwa-header__count').forEach((count) => { count.textContent = cart.item_count; });
          document.querySelectorAll('.siwa-header__bag').forEach((bag) => { bag.setAttribute('aria-label', `Bag, ${cart.item_count} items`); });
        }
        document.dispatchEvent(new CustomEvent('siwa:cart:updated', {
          detail: { cart, line: payload, open: true, source: 'product' },
        }));
        addButton.classList.add('is-added');
        stickyAddButton?.classList.add('is-added');
        if (addLabel) addLabel.textContent = 'Added to bag';
        if (stickyAddLabel) stickyAddLabel.textContent = 'Added';
        window.setTimeout(() => {
          addButton.classList.remove('is-added');
          stickyAddButton?.classList.remove('is-added');
          if (addLabel) addLabel.textContent = originalLabel;
          if (stickyAddLabel) stickyAddLabel.textContent = originalStickyLabel;
        }, 1700);
      } catch (error) {
        if (addLabel) addLabel.textContent = originalLabel;
        if (stickyAddLabel) stickyAddLabel.textContent = originalStickyLabel;
        if (status) status.textContent = error.message || 'Could not add this fragrance.';
      } finally {
        addButton.disabled = addButton.dataset.available !== 'true';
        if (stickyAddButton) stickyAddButton.disabled = stickyAddButton.dataset.available !== 'true';
      }
    });
  };
  document.querySelectorAll('[data-siwa-product]').forEach(initProduct);
  document.addEventListener('shopify:section:load', (event) => { event.target.querySelectorAll('[data-siwa-product]').forEach(initProduct); });
})();
